<template>
  <div>
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.icon`]="{ item }"  >
        <v-icon>{{ item.icon }}</v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
      <!-- Using  Hexodus solves the issue -->
      <template v-slot:[`item.is_top_category`]="{ item }">
        {{ item.is_top_category == 1 ? "Yes" : "No" }}
      </template>
    </CardedTable>
  </div>
</template>

<script>
// parseInt(item.is_top_category) == 1 ? 'Yes' : 'no'
// v-slot:cell(remove_btn)="data"
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminCategoriesList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      items: [],
      headers: [
        {
          text: "Icon",
          align: "start",
          sortable: false,
          value: "icon",
          filterable: false,
        },
        { text: "Name", value: "name" },
        { text: "Is Top", value: "is_top_category", align: "center", },
        { text: "Top Level", value: "top_category_level", align: "center" },
        {
          text: "Sub Categories",
          value: "sub_categories.length",
          align: "center",
          filterable: false,
        },
        { text: "Busineses", value: "belongings.length", align: "center",},
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Categories.get_categories(
        {
          is_admin: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading categories on admin categories list"
          );
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/categories/view/" + item.id);
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Categories List",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Categories",
          disabled: false,
          href: "/admin/categories",
        },
        {
          text: "List",
          disabled: true,
          href: "/admin/categories/list",
        },
      ],
    });
    this.load_items();
  },
};
</script>